import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { sanitizeParams } from "utils/miscUtils";
import { updateQueryParams } from "utils/queryParamsHelper";

const getInitilFilters = (searchParams, initialValues) => {
  let filters = {};
  const keys = Object.keys(initialValues);

  for (let key of keys) {
    if (searchParams.get(key)) {
      filters[key] = searchParams.get(key);
    }
  }
  return { ...initialValues, ...filters };
};

const useFilterOptionsHook = ({ initialValues = {} }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialFilterOptions = getInitilFilters(searchParams, initialValues);
  const [filterOptions, setFilterOptions] = useState(initialFilterOptions);

  const onChange = ({ name, value }) => {
    setFilterOptions((st) => ({ ...st, [name]: value }));
    updateQueryParams({ [name]: value }, setSearchParams);
  };

  const reset = () => {
    setFilterOptions(initialValues);
    updateQueryParams({ ...sanitizeParams(initialValues) }, setSearchParams);
  };

  return {
    onChange,
    reset,
    filterOptions,
  };
};

export default useFilterOptionsHook;
